module.exports = __webpack_public_path__ + "static/img/01.f64e632.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/01.png
// module id = ET9Y
// module chunks = 1